export enum DOCUMENT_TYPES {
  ENVIRONMENTAL_RESOURCE_PERMIT = 'Environmental Resource Permit',
  ACCESSIBILITY_COMPLIANCE = 'Accessibility Compliance',
  BUSINESS_LICENCE = 'Business Licence',
  SITE_PLAN = 'Site Plan',
  BUILDING_PERMIT = 'Building Permit',
  DEVELOPMENT_PERMIT = 'Development Permit',
  ELECTRICAL_PERMIT = 'Electrical Permit',
  ENTITLEMENT = 'Entitlement',
  PLAT = 'Plat',
  LAND_TITLE_CHANGE = 'Land Title Change',
  MECHANICAL_PERMIT = 'Mechanical Permit',
  PLUMBING_PERMIT = 'Plumbing Permit',
  REZONING = 'Rezoning',
  TENANCY_CHANGE = 'Tenancy Change',
}

/*
 * Special case for handling Accessibility Compliance toggling.
 * When we toggle the entire section, this is the default selection we want to use.
 */
export const DEFAULT_ACCESSIBILITY_COMPLIANCE_SELECTION = {
  id: 14,
  categories: [454, 568, 569],
  statuses: [1033],
};
